import { HandlerEvent } from 'post-robot';
import {
  getApiKey,
  getClientId,
  getCorrelationId,
  getExternalClientId,
  getInitData,
  getSrcDpaId
} from 'communicator/store/selectors';
import fetchLogEvent from 'communicator/utils/api/log-event';

// START GENAI@GHCOPILOT
export default function pushEvents(event: HandlerEvent<object>) {
  fetchLogEvent({
    correlationId: getCorrelationId(),
    request: {
      ME: getClientId(),
      XCL: getExternalClientId(),
      ...event.data,
      // START GENAI@GHCOPILOT
      dpaId: getSrcDpaId(),
      dpaName: getInitData()?.dpaData?.dpaPresentationName,
      srcInitiatorId: getApiKey()
      // END GENAI@GHCOPILOT
    }
  });
}
// END GENAI@GHCOPILOT
